import { Theme, withStyles } from "@material-ui/core/styles";
import { LightColors } from "@thingsw/pitta-design-system";
import { ProgressSlider } from "../ProgressSlider";

export const VolumeSlider = withStyles((theme: Theme) => ({
  track: {
    color: LightColors.primary["0"],
    height: 4,
  },
  thumb: {
    color: LightColors.primary["0"],
    marginTop: -4,
  },
}))(ProgressSlider);
